/* Counter.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./Counter.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect, useMemo, useRef } from 'react';
import { SlideIn, ExitingPersistence } from '@atlaskit/motion';
import { formatLargeNumber } from '../shared/utils';
import { B400 } from '@atlaskit/theme/colors';
var containerStyle = null;
var counterLabelStyle = null;
var countStyle = null;
var highlightStyle = null;
var darkerFontStyle = null;
var updatedStyles = null;

/**
 * Test id for component top level div
 */
export var RENDER_COMPONENT_WRAPPER = 'counter-wrapper';

/**
 * Test id for wrapper div of the counter inside the slider
 */
export var RENDER_COUNTER_TESTID = 'counter-container';

/**
 * Counter label value wrapper div
 */
export var RENDER_LABEL_TESTID = 'counter_label_wrapper';
/**
 * Display reaction count next to the emoji button
 */
export var Counter = function Counter(_ref) {
  var _ref$highlight = _ref.highlight,
    highlight = _ref$highlight === void 0 ? false : _ref$highlight,
    limit = _ref.limit,
    overLimitLabel = _ref.overLimitLabel,
    className = _ref.className,
    value = _ref.value,
    _ref$animationDuratio = _ref.animationDuration,
    animationDuration = _ref$animationDuratio === void 0 ? 'medium' : _ref$animationDuratio,
    useDarkerFont = _ref.useDarkerFont,
    useUpdatedStyles = _ref.useUpdatedStyles;
  var getLabel = function getLabel(value) {
    // Check if reached limit
    if (limit && overLimitLabel && value >= limit) {
      return overLimitLabel || '';
    } else if (value === 0) {
      return '';
    } else {
      return formatLargeNumber(value);
    }
  };
  var lastValue = useRef();
  var label = getLabel(value);
  useEffect(function () {
    lastValue.current = value;
  }, [value]);
  var isIncreasing = useMemo(function () {
    return lastValue.current ? lastValue.current < value : false;
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_11c81o8v _1reo15vq _18m915vq _syaz131l _kqswh2mm _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvidpf _vwz4dlk8", useDarkerFont && "_syaz1gjq", useUpdatedStyles && "_19pkv77o", className]),
    "data-testid": RENDER_COMPONENT_WRAPPER
  }, /*#__PURE__*/React.createElement(ExitingPersistence, null, /*#__PURE__*/React.createElement(SlideIn, {
    enterFrom: isIncreasing ? 'top' : 'bottom',
    exitTo: isIncreasing ? 'top' : 'bottom',
    key: value,
    duration: animationDuration
  }, function (motion, direction) {
    return /*#__PURE__*/React.createElement("div", {
      ref: motion.ref,
      style: {
        position: direction === 'exiting' ? 'absolute' : undefined
      }
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      ,
      className: ax(["_1e0c1txw _2lx21bp4", motion.className]),
      "data-testid": RENDER_COUNTER_TESTID
    }, /*#__PURE__*/React.createElement("span", {
      "data-testid": RENDER_LABEL_TESTID,
      key: value,
      className: ax(["_1x821ts4", highlight && "_syazln51"]),
      style: {
        "--_1hfkvbo": ix("var(--ds-text-selected, ".concat(B400, ")"))
      }
    }, label));
  })));
};